import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, isRef as _isRef } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-center justify-space-between" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "text-h4" }, "Учет использованных карт")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("th", null, "Муниципальное образование", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("th", null, "Торговый объект", -1)
const _hoisted_4 = ["title"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "font-weight-bold" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_9 = { class: "text-rigth" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  class: "font-weight-bold"
}, "Итого по категориям:", -1)
const _hoisted_12 = { key: 1 }
const _hoisted_13 = ["colspan"]
const _hoisted_14 = { class: "font-weight-bold text-center" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = ["colspan"]

import { Ref, computed, ref } from 'vue'
import {
  CitizenCategory,
  GroupedUsedCardsStat,
  MunicipalEntitiesService,
  Paging,
  SalesPointsService,
  UsedCardsStatsService,
  citizenCategoryShorthand,
  enumGetKeys,
  citizenCategoryName,
  salesPointGetAddress,
  GlobalSettingsService,
  GlobalSettings,
  AppAuthService,
  Permissions,
} from '@prodcard/core'
import { createCtx, handleError, monthsMock, useWatcherSavedRef, yearsMock } from '../../../../helpers'
import FilterBox, { SearchParams } from './FilterBox.vue'
import { Pagination } from '../../../../components'
import { usePaginator, Paginator, useAuthPermissions } from '../../../../mixins'
import { toArray } from 'lodash'
import { saveWorkbook } from '../../../../common'
import { Workbook } from 'exceljs'
import { createSheetUsedCardsStats } from './createSheetUsedCardsStats'


export default /*#__PURE__*/_defineComponent({
  __name: 'UsedCardsStatListPage',
  props: {
    usedCardsStatsService: {},
    salesPointsService: {},
    municipalEntitiesService: {},
    globalSettingsService: {},
    authService: {}
  },
  setup(__props: any) {

const props = __props;



const { currentMunicipalEntityId, hasPermissions } = useAuthPermissions(props.authService)
const hasView = computed(() => hasPermissions(Permissions.USED_CARDS_STATS_VIEW))
const hasMeView = computed(() => hasPermissions(Permissions.ME_USED_CARDS_STATS_VIEW))
const hasManage = computed(
  () => hasPermissions(Permissions.USED_CARDS_STATS_MANAGE) || hasPermissions(Permissions.ME_USED_CARDS_STATS_MANAGE),
)

const { paginator, count, getPageCount, resetPage } = usePaginator('UsedCardsStatPaginator')
const loadingTableToDownload = ref(false)

const globalSettings: Ref<GlobalSettings | undefined> = ref()
const groupedBySP: Ref<GroupedUsedCardsStat[]> = ref([])
const groupedByME: Ref<GroupedUsedCardsStat[]> = ref([])
const loading = ref(false)
const searchParams: Ref<SearchParams> = useWatcherSavedRef('usedCardsStatListParams', {
  dateFrom: undefined,
  dateTo: undefined,
  salesPointId: undefined,
  municipalEntityId: !hasView.value && hasMeView.value ? currentMunicipalEntityId.value : undefined,
})
const citizenCategoryList = enumGetKeys(CitizenCategory)

const update = (paginator: Paginator, filter: SearchParams) => {
  handleError(async () => {
    const from = (paginator.page - 1) * paginator.per
    const { resGroupedBySP, resGroupedByME } = await fetchData(filter, { from, count: paginator.per })

    groupedBySP.value = resGroupedBySP.items
    count.value = resGroupedBySP.total
    groupedByME.value = resGroupedByME
  }, loading)
}

const fetchData = async (filter: SearchParams, paging?: Paging) => {
  const ctx = createCtx()

  if (!globalSettings.value) {
    globalSettings.value = await props.globalSettingsService.load(ctx)
  }

  const time = globalSettings.value?.reportsCloseTime
  const dateFrom = filter.dateFrom
  const dateTo = filter.dateTo
  const { groupedBySP: resGroupedBySP, groupedByME: resGroupedByME } = await props.usedCardsStatsService.formReport(
    ctx,
    {
      paging,
      filter: {
        ...filter,
        dateFrom: dateFrom
          ? new Date(
              new Date(dateFrom).setHours(time?.hour() || 0, time?.minute() || 0, time?.second() || 0) -
                3600 * 1000 * 24,
            )
          : undefined,
        dateTo: dateTo
          ? new Date(new Date(dateTo).setHours(time?.hour() || 0, time?.minute() || 0, time?.second() || 0))
          : undefined,
      },
    },
  )

  return { resGroupedBySP, resGroupedByME }
}

const updateSearchParams = (newSearchParams: SearchParams) => {
  searchParams.value = newSearchParams
  resetPage()
  update(paginator.value, searchParams.value)
}

const fullSumGroupedUsedCardsStat = (groupedUsedCardsStat: GroupedUsedCardsStat[]): number => {
  return groupedUsedCardsStat.reduce((acc, curr) => {
    toArray(curr.values).forEach(item => {
      acc += item
    })
    return acc
  }, 0)
}

update(paginator.value, searchParams.value)

const downloadTable = (filter: SearchParams) => {
  handleError(async () => {
    const workbook = new Workbook()
    const { resGroupedBySP, resGroupedByME } = await fetchData(filter, {})
    createSheetUsedCardsStats(workbook, 'Учет использованных карт', {
      groupedBySP: resGroupedBySP.items,
      groupedByME: resGroupedByME,
    })
    await saveWorkbook(workbook, 'Учет_использованных_карт')
  }, loadingTableToDownload)
}

return (_ctx: any,_cache: any) => {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createBlock(_component_v_sheet, null, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(FilterBox, {
        "default-search-params": _unref(searchParams),
        "sales-points-service": _ctx.salesPointsService,
        "municipal-entities-service": _ctx.municipalEntitiesService,
        "month-items": _unref(monthsMock),
        "year-items": _unref(yearsMock),
        loading: loading.value,
        "readonly-me": !hasView.value && hasMeView.value,
        class: "my-5",
        onUpdate: updateSearchParams
      }, null, 8, ["default-search-params", "sales-points-service", "municipal-entities-service", "month-items", "year-items", "loading", "readonly-me"]),
      _createVNode(_component_v_card, {
        elevation: "0",
        loading: loading.value,
        disabled: loading.value,
        class: "mt-6"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_table, { hover: "" }, {
            default: _withCtx(() => [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _hoisted_2,
                  _hoisted_3,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(citizenCategoryList), (citizenCategory) => {
                    return (_openBlock(), _createElementBlock("th", {
                      key: citizenCategory,
                      title: _unref(citizenCategoryName)(citizenCategory as CitizenCategory),
                      class: "text-center"
                    }, _toDisplayString(_unref(citizenCategoryShorthand)(citizenCategory as CitizenCategory)), 9, _hoisted_4))
                  }), 128))
                ])
              ]),
              (groupedByME.value.length > 0)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedByME.value, (me) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: me.municipalEntity.id
                      }, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", _hoisted_6, _toDisplayString(me.municipalEntity.name), 1),
                          _hoisted_7,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(citizenCategoryList), (citizenCategory) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: citizenCategory,
                              class: "font-weight-bold text-center"
                            }, _toDisplayString(me.values[citizenCategory as CitizenCategory]), 1))
                          }), 128))
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedBySP.value.filter(item => item.municipalEntity.id === me.municipalEntity.id), (cip) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: cip.salesPoint.id
                          }, [
                            _hoisted_8,
                            _createElementVNode("td", _hoisted_9, [
                              _createTextVNode(_toDisplayString(_unref(salesPointGetAddress)(cip.salesPoint)) + " ", 1),
                              (cip.salesPoint.comment)
                                ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                    key: 0,
                                    text: cip.salesPoint.comment,
                                    activator: "parent",
                                    location: "top left",
                                    "max-width": "350px"
                                  }, null, 8, ["text"]))
                                : _createCommentVNode("", true)
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(citizenCategoryList), (citizenCategory) => {
                              return (_openBlock(), _createElementBlock("td", {
                                key: citizenCategory,
                                class: "text-center"
                              }, _toDisplayString(cip.values[citizenCategory as CitizenCategory]), 1))
                            }), 128))
                          ]))
                        }), 128))
                      ], 64))
                    }), 128)),
                    (groupedByME.value.length > 1)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                          _hoisted_11,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(citizenCategoryList), (citizenCategory) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: citizenCategory,
                              class: "font-weight-bold text-center"
                            }, _toDisplayString(groupedBySP.value.reduce((acc, curr) => (acc += curr.values[citizenCategory as CitizenCategory]), 0)), 1))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (groupedBySP.value.length > 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                          _createElementVNode("td", {
                            colspan: _unref(citizenCategoryList).length + 1,
                            class: "font-weight-bold"
                          }, "Общий итог:", 8, _hoisted_13),
                          _createElementVNode("td", _hoisted_14, _toDisplayString(fullSumGroupedUsedCardsStat(groupedBySP.value)), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : (groupedBySP.value.length === 0 && !loading.value)
                  ? (_openBlock(), _createElementBlock("tfoot", _hoisted_15, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", {
                          colspan: 2 + _unref(toArray)(_unref(CitizenCategory)).length,
                          class: "text-center",
                          style: {"border-top":"0"}
                        }, "Нет данных", 8, _hoisted_16)
                      ])
                    ]))
                  : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_unref(Pagination), {
            modelValue: _unref(paginator),
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event: any) => (_isRef(paginator) ? (paginator).value = $event : null)),
              _cache[1] || (_cache[1] = ($event: any) => (update($event, _unref(searchParams))))
            ],
            "page-count": _unref(getPageCount),
            disabled: loading.value || _unref(getPageCount) === 0,
            class: "mt-5"
          }, null, 8, ["modelValue", "page-count", "disabled"])
        ]),
        _: 1
      }, 8, ["loading", "disabled"]),
      _createElementVNode("div", null, [
        (globalSettings.value && globalSettings.value.reportsCloseTime)
          ? (_openBlock(), _createBlock(_component_v_alert, {
              key: 0,
              icon: "$info",
              color: "info",
              variant: "outlined",
              "max-width": "550",
              class: "mt-5",
              text: `Внесение данных доступно до ${globalSettings.value.reportsCloseTime.toString()}. Данные, внесенные после ${globalSettings.value.reportsCloseTime.toString()} суммируются в итоги следующего дня.`
            }, null, 8, ["text"]))
          : _createCommentVNode("", true),
        _createVNode(_component_v_row, { class: "mt-2" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "auto" }, {
              default: _withCtx(() => [
                (hasManage.value)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      to: "/used-cards-stats/new"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Внести данные")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "auto" }, {
              default: _withCtx(() => [
                (_unref(hasPermissions)(_unref(Permissions).USED_CARD_STATS_TABLE_EXPORT))
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      color: "primary",
                      variant: "outlined",
                      "prepend-icon": "mdi-download-outline",
                      loading: loadingTableToDownload.value,
                      disabled: loading.value,
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (downloadTable(_unref(searchParams))))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Скачать ")
                      ]),
                      _: 1
                    }, 8, ["loading", "disabled"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})